import { ReactElement, ReactNode } from "react";

export default function MenuSection(props: {
  children: ReactNode;
}): ReactElement {
  return <ul className="pb-6">{props.children}</ul>;
}
